import { useSession } from "@punchup/data/legacy";

export default useSession;
